
<template>
    <div>
        <div class="hero-wrap">
            <div class="hero-mask opacity-7 bg-primary-dark"></div>
            <div class="hero-bg hero-bg-scroll" style="background-image: url('/images/business/invoice.png');"></div>
            <div class="hero-content mx-auto w-100 h-100 d-flex flex-column">
                <div class="container py-5">
                    <div class="row flex-row-reverse justify-content-center">
                        <div class="col-md-8 text-center pb-5">
                            <h2 class="text-14 text-white font-weight-bolder mb-3">
                                Business
                            </h2>
                            <p class="text-5 text-white-50 mb-4">
                                Run your business smarter, not harder—streamline operations, boost efficiency, and stay in control with one powerful platform.
                            </p>
                            <div class="my-5">
                                <template v-if="user.email">
                                    <can permission="input-transactions">
                                        <router-link class="btn btn-light btn-block d-lg-inline mb-2 mr-2" to="/business/transact">
                                            <i class="fas fa-upload ml-2"></i>
                                            Bill Payments
                                        </router-link>
                                    </can>
                                    <router-link class="btn btn-light btn-block d-lg-inline mb-2 mr-2" to="/business/dashboard">
                                        <i class="fas fa-chart-bar ml-2"></i>
                                        Dashboard
                                    </router-link>
                                    <router-link class="btn btn-light btn-block d-lg-inline mb-2 mr-2" to="/business/transactions">
                                        <i class="fas fa-history ml-2"></i>
                                        Transaction history
                                    </router-link>
                                </template>
                                <template v-else>
                                    <a class="btn btn-light btn-block d-lg-inline mb-2 mr-2" href="/business/auth">
                                        <i class="fas fa-atom"></i>
                                        Sign In
                                    </a>
                                    <a class="btn btn-light btn-block d-lg-inline mb-2 mr-2" href="/business/register">
                                        <i class="fas fa-plus-circle"></i>
                                        Sign Up
                                    </a>
                                    <!-- New 'Book A Demo' Button -->
                                    <a class="btn btn-light btn-block d-lg-inline mb-2 mr-2" href="https://outlook.office365.com/owa/calendar/MagetsiDemo@magetsi.co.zw/bookings/">
                                        <i class="fas fa-calendar-alt"></i>
                                        Book A Demo
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section class="section py-5 bg-white">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mb-5 p-lg-5">
                        <h1 class="text-8 font-weight-bold mb-5 text-left">
                            Streamlined Solutions For Organizations To Boost Productivity.
                        </h1>
                        <div class="text-3 text-justify">
                            <p>
                                At Magetsi, we understand the complexities of managing finances, hosting events, and maintaining seamless payment processes within organizations. That’s why we created Magetsi Business, a comprehensive platform that combines our Corporate Bill Payment, Events, and Biller products. Magetsi Business is designed for businesses, non-profits, and other organizations, Magetsi Business simplifies your operations so you can focus on what truly matters—growing your impact.                </p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-4">
                        <div class="sidebar-popup p-5" style="padding: 20px; background-color: #fff; border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); z-index: 1000;">
                            <div class="row">
                                <div class="col-8">
                                    <h1 class="text-large font-weight-bold" style="color: #FFCA33;">75%</h1>
                                </div>
                            </div>
                            <p class="text-dark font-weight-bold">
                                Amplify your team’s productivity by 75% with Magetsi Business.
                            </p>
                            <p class="text-muted">
                                Turn a 2-hour task into 10 minutes. Want to know how? We can help. <span>👇</span>
                            </p>
                            <a class="btn btn-primary btn-block mb-2" href='https://outlook.office365.com/owa/calendar/MagetsiDemo@magetsi.co.zw/bookings/'>Book a Free Demo</a>
                            <a class="btn btn-outline-primary btn-block" href="/business/register">Sign Up Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h1 class="text-center text-8 font-weight-bold mb-4 py-5">Your All-in-One Platform</h1>
                <p class="text-center text-3 mb-4">Magetsi Business empowers organizations by consolidating three critical services into a single, user-friendly platform: </p>

                <!-- Corporate Bill Payments Section -->
                <div class="row mb-5">
                    <div class="col-md-4">
                        <div class="feature-box bg-white p-4 text-left shadow-sm rounded">
                            <h3 class="font-weight-bold">Corporate Bill Payments</h3>
                            <p>Managing bulk payments can be time-consuming and prone to errors. Our solution simplifies this process for companies of all sizes.</p>
                            <button class="btn btn-link" data-toggle="collapse" data-target="#corporateBillDetails">View Details</button>
                            <div id="corporateBillDetails" class="collapse">
                                <p><strong>Key Features:</strong></p>
                                <ul>
                                    <li>Effortless bulk payments with Excel upload functionality</li>
                                    <li>Detailed transaction history for tracking</li>
                                    <li>Secure payment options: EcoCash, Visa, and MasterCard</li>
                                </ul>
                                <a href="/business/corporate-landing" class="btn btn-primary mt-3">Go to Corporate Bill Payments</a>
                            </div>
                        </div>
                    </div>

                    <!-- Event Ticketing Section -->
                    <div class="col-md-4">
                        <div class="feature-box bg-white p-4 text-left shadow-sm rounded">
                            <h3 class="font-weight-bold">Event Ticketing</h3>
                            <p>Our comprehensive event ticketing solution is designed to accommodate a range of events, providing a seamless experience for attendees. From purchasing tickets to gaining entry, delivering satisfaction for all users.</p>
                            <button class="btn btn-link" data-toggle="collapse" data-target="#eventTicketDetails">View Details</button>
                            <div id="eventTicketDetails" class="collapse">
                                <p><strong>Key Features:</strong></p>
                                <ul>
                                    <li>QR code digital ticketing for security</li>
                                    <li>Real-time sales tracking and analytics</li>
                                    <li>Customizable ticketing options (VIP, early bird)</li>
                                </ul>
                                <a href="/tickets/landing" class="btn btn-primary mt-3">Go to Event Ticketing</a>
                            </div>
                        </div>
                    </div>

                    <!-- Biller Services Section -->
                    <div class="col-md-4">
                        <div class="feature-box bg-white p-4 text-left shadow-sm rounded">
                            <h3 class="font-weight-bold">Biller Services</h3>
                            <p>Designed for NGOs, churches, and more  to collect payments easily and maintain customer relationships, our solution simplifies financial transactions while enhancing engagement with customers and members.</p>
                            <button class="btn btn-link" data-toggle="collapse" data-target="#billerServiceDetails">View Details</button>
                            <div id="billerServiceDetails" class="collapse">
                                <p><strong>Key Features:</strong></p>
                                <ul>
                                    <li>Flexible payment channels</li>
                                    <li>Automated reminders for subscriptions</li>
                                    <li>Transparent reporting for financial management</li>
                                </ul>
                                <a href="/billers/landing" class="btn btn-primary mt-3">Go to Biller Page</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                </section>

                <!-- Why Choose Magetsi Business Section -->
        <section class="section py-5 bg-light">
            <div class="container">
                <h1 class="text-center text-8 font-weight-bold mb-4 py-5">Why Choose Magetsi Business?</h1>
                <p class="text-center mb-5 text-3">
                    Organizations across various sectors trust Magetsi Business to handle their payments and events because we deliver more than just a service—we offer solutions that make life easier. Here’s why you should choose us:
                </p>
                <div class="row mb-4 text-3">
                    <div class="col-md-6">
                        <div class="benefit-box text-left larger-font">
                            <strong>Efficiency at Your Fingertips:</strong>
                            <p>Our platform is designed with user convenience in mind. You can manage all your payment and ticketing needs from a single dashboard, saving you time and reducing administrative burdens.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="benefit-box text-left larger-font">
                            <strong>Tailored for Organizations:</strong>
                            <p>Magetsi Business is built specifically for the unique needs of organizations. Whether you're managing a corporate account, organizing a large-scale event, or collecting payments, our solutions are tailored to suit your operations.</p>
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-md-6">
                        <div class="benefit-box text-left larger-font">
                            <strong>Secure Transactions:</strong>
                            <p>We prioritize the security of your financial data and transactions. With advanced encryption and reliable payment gateways, you can trust Magetsi Business to safeguard your operations.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="benefit-box text-left larger-font">
                            <strong>Exceptional Support:</strong>
                            <p>Our dedicated support team is always on hand to assist you. From onboarding to troubleshooting, we ensure that your experience with Magetsi Business is smooth and hassle-free.</p>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section py-5 bg-light-4">
            <div class="container">
                <h1 class="text-center text-8 font-weight-bold mb-5">Who Can Benefit from Magetsi Business?</h1>
                <p class="text-center text-3 mb-5">Our solutions are versatile and cater to a wide range of industries and organizations</p>

                <!-- Benefits Section -->
                <div class="accordion" id="whyChooseMagetsi">

                    <!-- Corporate Entities -->
                    <div class="card shadow-sm mb-4">
                        <div class="card-header p-3" id="headingEfficiency">
                            <h5 class="mb-0">
                                <button class="btn btn-link text-left text-dark font-weight-bold" type="button" data-toggle="collapse" data-target="#collapseEfficiency" aria-expanded="true" aria-controls="collapseEfficiency">
                                    <i class="fas fa-users mr-2"></i> Corporate Entities
                                </button>
                            </h5>
                        </div>
                        <div id="collapseEfficiency" class="collapse show" aria-labelledby="headingEfficiency" data-parent="#whyChooseMagetsi">
                            <div class="card-body">
                                Simplify bulk payments for utilities, airtime, and other recurring needs.
                            </div>
                        </div>
                    </div>

                    <!-- Event Planners -->
                    <div class="card shadow-sm mb-4">
                        <div class="card-header p-3" id="headingTailored">
                            <h5 class="mb-0">
                                <button class="btn btn-link text-left text-dark font-weight-bold" type="button" data-toggle="collapse" data-target="#collapseTailored" aria-expanded="false" aria-controls="collapseTailored">
                                    <i class="fas fa-calendar-alt mr-2"></i> Event Planners
                                </button>
                            </h5>
                        </div>
                        <div id="collapseTailored" class="collapse" aria-labelledby="headingTailored" data-parent="#whyChooseMagetsi">
                            <div class="card-body">
                                Receive offerings and donations securely.
                            </div>
                        </div>
                    </div>

                    <!-- Subscription-Based Businesses -->
                    <div class="card shadow-sm mb-4">
                        <div class="card-header p-3" id="headingSecure">
                            <h5 class="mb-0">
                                <button class="btn btn-link text-left text-dark font-weight-bold" type="button" data-toggle="collapse" data-target="#collapseSecure" aria-expanded="false" aria-controls="collapseSecure">
                                    <i class="fas fa-lock mr-2"></i> Subscription-Based Businesses
                                </button>
                            </h5>
                        </div>
                        <div id="collapseSecure" class="collapse" aria-labelledby="headingSecure" data-parent="#whyChooseMagetsi">
                            <div class="card-body">
                                Receive memberships and recurring services.
                            </div>
                        </div>
                    </div>

                    <!-- Businesses Targeting Diaspora Clients -->
                    <div class="card shadow-sm mb-4">
                        <div class="card-header p-3" id="headingScalable">
                            <h5 class="mb-0">
                                <button class="btn btn-link text-left text-dark font-weight-bold" type="button" data-toggle="collapse" data-target="#collapseScalable" aria-expanded="false" aria-controls="collapseScalable">
                                    <i class="fas fa-globe mr-2"></i> Businesses Targeting Diaspora Clients
                                </button>
                            </h5>
                        </div>
                        <div id="collapseScalable" class="collapse" aria-labelledby="headingScalable" data-parent="#whyChooseMagetsi">
                            <div class="card-body">
                                Receive international payments through our billers.
                            </div>
                        </div>
                    </div>

                    <!-- NGOs & Charities -->
                    <div class="card shadow-sm mb-4">
                        <div class="card-header p-3" id="headingSupport">
                            <h5 class="mb-0">
                                <button class="btn btn-link text-left text-dark font-weight-bold" type="button" data-toggle="collapse" data-target="#collapseSupport" aria-expanded="false" aria-controls="collapseSupport">
                                    <i class="fas fa-hand-holding-heart mr-2"></i> NGOs & Charities
                                </button>
                            </h5>
                        </div>
                        <div id="collapseSupport" class="collapse" aria-labelledby="headingSupport" data-parent="#whyChooseMagetsi">
                            <div class="card-body">
                                Collect donations and manage financial records seamlessly.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>


        <section class="section py-5 bg-light">
            <div class="container">
                <h1 class="text-center text-8 font-weight-bold mb-5">How Magetsi Business is Transforming Operations for Organizations in Different Sectors</h1>

                <!-- Fleet Management Companies Section -->
                <div class="row mb-5">
                    <div class="col-md-4 text-center">
                        <div class="feature-icon mb-3">
                            <i class="fas fa-truck text-dark fa-3x"></i>
                        </div>
                        <h4 class="font-weight-bold">Fleet Management Companies</h4>
                        <p>Magetsi Business has revolutionized operations for tracking companies across Zimbabwe through our Corporate Bill Payments service. Managing multiple SIM card recharges manually can be time-consuming, error-prone, and costly.</p>
                        <button class="btn btn-link" data-toggle="collapse" data-target="#fleetManagementDetails">View Benefits</button>
                        <div id="fleetManagementDetails" class="collapse">
                            <ul>
                                <li><strong>Saved Time:</strong> Bulk SIM card recharges eliminate hours of manual work each month.</li>
                                <li><strong>Cost Efficiency:</strong> Our bulk payment system reduces overhead costs.</li>
                                <li><strong>Minimized Errors:</strong> Removing human error ensures uninterrupted service for clients.</li>
                            </ul>
                        </div>
                    </div>

                    <!-- Event Organizers Section -->
                    <div class="col-md-4 text-center">
                        <div class="feature-icon mb-3">
                            <i class="fas fa-ticket-alt text-success fa-3x"></i>
                        </div>
                        <h4 class="font-weight-bold">Event Organizers</h4>
                        <p>Magetsi Business is a trusted and reliable partner for event organizers, offering a seamless solution for streamlining ticket distribution through our comprehensive Event Ticketing service and effectively addressing key industry challenges.</p>
                        <button class="btn btn-link" data-toggle="collapse" data-target="#eventOrganizerDetails">View Benefits</button>
                        <div id="eventOrganizerDetails" class="collapse">
                            <ul>
                                <li><strong>Fraud Prevention:</strong> QR code verification reduces fake tickets, ensuring only genuine attendees gain entry.</li>
                                <li><strong>Financial Transparency:</strong> Detailed reconciliation reports provide full visibility of ticket sales.</li>
                                <li><strong>Minimal Cash Handling:</strong> Online payments reduce the risks associated with cash transactions.</li>
                            </ul>
                        </div>
                    </div>

                    <!-- Local Churches Section -->
                    <div class="col-md-4 text-center">
                        <div class="feature-icon mb-3">
                            <i class="fas fa-church text-primary fa-3x"></i>
                        </div>
                        <h4 class="font-weight-bold">Local Churches</h4>
                        <p>Magetsi Business offers comprehensive support to local churches by streamlining their financial processes, enabling them to focus on their core mission, strengthen community engagement, and make a lasting impact in the lives of those they serve</p>
                        <button class="btn btn-link" data-toggle="collapse" data-target="#churchDetails">View Benefits</button>
                        <div id="churchDetails" class="collapse">
                            <ul>
                                <li><strong>Instant Airtime Recharges:</strong> Keeps missionaries connected without delays for effective coordination.</li>
                                <li><strong>Bulk Utility Payments:</strong> Simplifies utility bill payments, reducing administrative burden.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Join the Digital Transformation Section -->
        <section class="digital-transformation py-5 bg-light-4">
            <div class="container">
                <h3 class="text-center font-weight-bold mb-4 py-5">Join the Digital Transformation with Magetsi Business</h3>

                <div class="row text-left">
                    <!-- Save Time -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3 text-center">
                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 24 24">
                                <path stroke="blue" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                            </svg>

                        </div>
                        <h5 class="font-weight-bold text-center">Save Time</h5>
                        <p>Automate bulk payments and ticketing, reducing time spent on repetitive tasks.</p>
                    </div>

                    <!-- Boost Transparency -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3 text-center">
                            <svg class="w-[25px] h-[25px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 24 24">
                                <path stroke="orange" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4.5V19a1 1 0 0 0 1 1h15M7 14l4-4 4 4 5-5m0 0h-3.207M20 9v3.207"/>
                            </svg>

                        </div>
                        <h5 class="font-weight-bold text-center">Boost Transparency</h5>
                        <p>Get real-time data and detailed reporting for informed decision-making.</p>
                    </div>

                    <!-- Secure Transactions -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3 text-center">
                            <svg class="w-[25px] h-[25px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 24 24">
                                <path stroke="purple" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14v3m-3-6V7a3 3 0 1 1 6 0v4m-8 0h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1Z"/>
                            </svg>

                        </div>
                        <h5 class="font-weight-bold text-center">Secure Transactions</h5>
                        <p>Advanced encryption ensures data safety and secure financial operations.</p>
                    </div>

                    <!-- Streamline Operations -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3 text-center">
                            <svg class="w-[25px] h-[25px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z" clip-rule="evenodd"/>
                                <path fill-rule="evenodd" d="M15.026 21.534A9.994 9.994 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c2.51 0 4.802.924 6.558 2.45l-7.635 7.636L7.707 8.87a1 1 0 0 0-1.414 1.414l3.923 3.923a1 1 0 0 0 1.414 0l8.3-8.3A9.956 9.956 0 0 1 22 12a9.994 9.994 0 0 1-.466 3.026A2.49 2.49 0 0 0 20 14.5h-.5V14a2.5 2.5 0 0 0-5 0v.5H14a2.5 2.5 0 0 0 0 5h.5v.5c0 .578.196 1.11.526 1.534Z" clip-rule="evenodd"/>
                            </svg>

                        </div>
                        <h5 class="font-weight-bold text-center">Streamline Operations</h5>
                        <p>Manage payments, events, and billing from a single, intuitive platform.</p>
                    </div>
                </div>
            </div>
        </section>




        <!-- Call to Action Section -->
        <section class="cta-section py-5 text-center bg-light-4">
            <div class="container">
                <h4 class="font-weight-bold text-7 text-primary mb-3 large-font">Ready to Get Started?</h4>
                <p class="text-dark mb-4">
                    Transform your operations today with Magetsi Business. Whether you’re managing payments, hosting events, or collecting funds, we’ve got the tools you need to succeed.
                </p>
                <p class="text-dark mb-4">
                    Join us on this journey and discover how Magetsi Business can help your organization thrive.
                </p>

                <!-- Call to Action Buttons -->
                <div class="row justify-content-center mt-4">
                    <div class="col-md-4 mb-2">
                        <a href="/business/register" class="btn btn-primary btn-lg text-white px-5">Sign Up</a>
                    </div>
                    <div class="col-md-4 mb-2">
                        <a href="https://outlook.office365.com/owa/calendar/MagetsiDemo@magetsi.co.zw/bookings/" class="btn btn-outline-primary btn-lg px-5">Book a Demo</a>
                    </div>
                </div>
            </div>
        </section>


        <!-- Partners Section -->



    </div>
</template>

<script>
import Can from "../core/can";

export default {
    name: "business",
    components: {Can, WelcomeInfo: () => import("../shared/welcome-info")},
    data: function () {
        return {
            user: window.user
        }
    },
}
</script>
<style>

.text-large{
    font-size: 120px;
}

 .large-img {
     width: 400px;
     height: auto;


 }
.larger-font {
    font-size: 15px;

}

 .step-number {
     width: 60px;
     height: 60px;
     line-height: 60px;
     font-size: 24px;
     text-align: center;
     padding: 0;
     border-radius: 50%;
 }

.large-font {
    font-size: 50px;
}
</style>
